const actions = {
    GET_MOVEMENTS: 'GET_MOVEMENTS',
    SET_MOVEMENTS: 'SET_MOVEMENTS',
    GET_MOVEMENTS_BEGIN: 'GET_MOVEMENTS_BEGIN',
    GET_MOVEMENTS_FINISH: 'GET_MOVEMENTS_FINISH',
    SET_CURRENT_PAGE: 'SET_CURRENT_PAGE',
  
    getMovements: () => ({
        type: actions.GET_MOVEMENTS,
    }),
  
    setMovements: (data: any) => ({
        type: actions.SET_MOVEMENTS,
        data,
    }),
  
    getMovementsBegin: () => ({
        type: actions.GET_MOVEMENTS_BEGIN,
    }),
  
    getMovementsFinish: () => ({
        type: actions.GET_MOVEMENTS_FINISH,
    }),

    setCurrentPage: (page: number) => ({
        type: actions.SET_CURRENT_PAGE,
        page,
    })
};
  
export default actions;
  